/**
 * The faint concentric arcs behind the hero — a nod to the radio-wave mark in
 * the logo. Purely decorative, so it's hidden from assistive tech.
 */
export function HeroBackdrop() {
  return (
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 h-full w-full text-white/[0.06]"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1200 600"
    >
      <title>Radio waves</title>
      {[220, 330, 440, 560].map((r) => (
        <circle
          cx="120"
          cy="560"
          fill="none"
          key={r}
          r={r}
          stroke="currentColor"
          strokeWidth="28"
        />
      ))}
    </svg>
  );
}
